import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workRegionGrid: [],
    workRegionAll: [],
    workRegionShow: null,
    pageData: null,
  },
  mutations: {
    setWorkRegionGrid(state, payload) {
      state.workRegionGrid = payload
    },
    setWorkRegionAll(state, payload) {
      state.workRegionAll = payload
    },
    setWorkRegionShow(state, payload) {
      state.workRegionShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workRegionGrid: (state) => {
      return state.workRegionGrid
    },
    workRegionAll: (state) => {
      return state.workRegionAll
    },
    workRegionShow: (state) => {
      return state.workRegionShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkRegionGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url = rootState.apiDomain + '/api/admin/work/region/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkRegionGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkRegionAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/region/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkRegionAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkRegionShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/region/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkRegionShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkRegionCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/region',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkRegionUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/region',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkRegionDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/region/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
